/**
 * Checks if puzzle board is in solved state
 *
 * A board is solved when each tile is in its correct position,
 * i.e., board[i] === i for all indices.
 *
 * @param {number[]} board - Current board state
 * @returns {boolean} True if board is solved, false otherwise
 *
 * @example
 * isSolvedBoard([0, 1, 2, 3, 4, 5, 6, 7, 8])  // true (3x3 solved)
 * isSolvedBoard([0, 1, 2, 3, 4, 5, 6, 8, 7])  // false (last two swapped)
 * isSolvedBoard([8, 7, 6, 5, 4, 3, 2, 1, 0])  // false (reversed)
 */
export function isSolvedBoard (board) {
  for (let i = 0; i < board.length; i++) {
    if (board[i] !== i) return false
  }
  return true
}
